import Header from './components/Header';
import Hero from './components/Hero';
import Updates from './components/Updates';
import Cards from './components/Cards';
import Topics from './components/Topics';
import Index from './components/Index';
import FAQ from './components/FAQ';
import Features from './components/Features';
import About from './components/About';
import Media from './components/Media';
import AppSection from './components/AppSection';
import Contact from './components/Contact';
import Ranking from './components/Ranking';
import Carousel from './components/Carousel';
import Comments from './components/Comments';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Updates />
        <Cards />
        <Topics />
        <Index />
        <FAQ />
        <Features />
        <About />
        <Media />
        <AppSection />
        <Contact />
        <Ranking />
        <Carousel />
        <Comments />
      </main>
      <Footer />
    </>
  );
}